import AbstractCommand from "../../../core/application/AbstractCommand";
import KeyDecisionContentEvent from "../event/KeyDecisionContentEvent";
import KeyDecisionsConfig from "../model/KeyDecisionsConfig";
import KeyDecisionsModel from "../model/KeyDecisionsModel";

export default class KeyDecisionContentCompletedCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {KeyDecisionsModel} keyDecisionsModel 
     * @param {KeyDecisionsConfig} keyDecisionsConfig 
     */
    constructor(dispatcher, keyDecisionsModel, keyDecisionsConfig) {
        super(dispatcher);

        this._keyDecisionsModel = keyDecisionsModel;
        this._keyDecisionsConfig = keyDecisionsConfig;
    }

    execute(evt) {
        /** @type {KeyDecisionContentEvent} */
        const data = evt.params.data;
        const keyDecisionContent = data.content;

        const keyDecision = this._keyDecisionsModel.getAvailableKeyDecisionByContent(keyDecisionContent);

        console.log(`[KeyDecisionContentCompletedCommand] Key decision with content id '${keyDecisionContent.getContentID()}' becomes completed.`);

        // this._keyDecisionsModel.makeKeyDecisionUnavailable(keyDecision);
        this._keyDecisionsModel.completeKeyDecision(keyDecision);
    }
}